import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import DealerAdIframe from '../../dealer';
// This is actually the VideoStage unit, with different options
const MobileDevPageVideoBtf = /*#__PURE__*/ React.memo(({ safety ='off' , safetyState  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Primis, ADUNIT_MAP['MobileDevPageVideoStageGam'], safety, safetyState, {
        placementId: 113451,
        vpContent: 'plembed35b9omrwtkip',
        verticalOffset: 102,
        clientOnly: true,
        floatMode: 'belowboth'
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    if (advertIsOff === 'fallback') {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '300px',
                height: '200px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['MobileDevPageVideoStageGam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageVideoBtf.displayName = 'MobileDevPageVideoBtf';
export default MobileDevPageVideoBtf;
